import type { PersistenceOptions } from 'pinia-plugin-persistedstate'

/**
 * @description Pinia 持久化配置（白名单）
 * @param key storage key
 * @param paths 需要持久化的 state 字段
 */
const piniaPersistConfig = (key: string, paths: string[] = []): PersistenceOptions => {
  return {
    key,
    storage: window.localStorage,
    paths
  }
}

export default piniaPersistConfig
